module.exports = __webpack_public_path__ + "fonts/Calibre-Medium.115d3718.woff";